import React from "react";

type ShimmerProps = {
  className?: string;
};

const cn = (...classes: Array<string | undefined | null | false>) =>
  classes.filter(Boolean).join(" ");

export const Shimmer = ({ className }: ShimmerProps) => {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "shimmer-effect rounded-[10px] bg-[#ECEFFC]",
        className,
      )}
    />
  );
};

export default Shimmer;
